import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { INews } from '../../../models/INews';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { NavigationService } from '../../../services/navigation';
import { FONTS } from '../../../constants';
import { INew } from '../../../types';
import dayjs from 'dayjs';
import { htmlDecode } from '../../../services/utils/htmlDecode';

interface ClubNewItemProps {
  item: INew;
}

const lorem =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

const ClubNewItem: FC<ClubNewItemProps> = ({ item }) => {
  const isDesktop = useIsDesktop();

  return (
    <View style={styles.wrapper}>
      <TouchableOpacity
        onPress={() => {
          NavigationService.push<'ClubNewDetail'>('ClubNewDetail', {
            id: item.id,
          });
        }}
      >
        {item.thumb && (
          <Image
            source={{ uri: item.thumb }}
            style={{
              width: '100%',
              height: 200,
              resizeMode: 'cover',
            }}
          />
        )}
      </TouchableOpacity>
      <View style={{ padding: 10 }}>
        {isDesktop() && (
          <View style={{ paddingVertical: 10 }}>
            <Text style={styles.dayTextDesktop}>
              {dayjs(new Date(item.date * 1000)).format('MMM DD, YYYY')}
            </Text>
          </View>
        )}
        <View style={{}}>
          <TouchableOpacity
            onPress={() => {
              NavigationService.push<'ClubNewDetail'>('ClubNewDetail', {
                id: item.id,
              });
            }}
          >
            <Text style={styles.title} numberOfLines={2}>
              {item.title}
            </Text>
          </TouchableOpacity>
        </View>
        {!isDesktop() && (
          <View style={{ paddingVertical: 10 }}>
            <Text style={styles.dayText}>
              {dayjs(new Date(item.date * 1000)).format('MMM DD, YYYY')}
            </Text>
          </View>
        )}
        <View
          style={[
            styles.horizontalLine,
            isDesktop() && { marginTop: 15, marginBottom: 10 },
          ]}
        />
        <View style={{ marginVertical: 10 }}>
          <Text
            style={isDesktop() ? styles.dayTextDesktop : styles.dayText}
            numberOfLines={3}
          >
            {htmlDecode(item.content)}
          </Text>
        </View>
        <View
          style={{
            alignSelf: 'flex-start',
            marginTop: 10,
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Button
            text="READ MORE"
            style={STYLE_VARS.blueButton}
            onPress={() => {
              NavigationService.push<'ClubNewDetail'>('ClubNewDetail', {
                id: item.id,
              });
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default ClubNewItem;

const styles = StyleSheet.create({
  wrapper: {
    borderColor: STYLE_VARS.fccDarkGrey,
    borderWidth: 0.5,
    marginVertical: 20,
  },
  title: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 18,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  dayText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
  dayTextDesktop: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 15,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  horizontalLine: {
    width: 30,
    height: 3,
    backgroundColor: STYLE_VARS.primaryColor,
  },
});
